import { ISpace } from "@/features/space/types/space.types.ts";

export interface ITabMeta {
  description?: string | null;
  isDefault?: boolean;
}

export interface IPage {
  id: string;
  slugId: string;
  publicSlug?: string | null;
  urlPath?: string | null;
  title: string;
  content: string;
  icon: string;
  coverPhoto: string;
  parentPageId: string;
  creatorId: string;
  spaceId: string;
  workspaceId: string;
  isLocked: boolean;
  lastUpdatedById: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  position: string;
  hasChildren: boolean;
  canEdit?: boolean;
  isGroup?: boolean;
  externalUrl?: string | null;
  hidden?: boolean;
  isTab?: boolean;
  tabMeta?: ITabMeta | null;
  tabId?: string | null;
  kind?: "page" | "group" | "link";
  // Meta description for search engines / link previews. Empty string
  // means "not set" — the public site falls back to an auto-generated
  // excerpt of the page content.
  seoDescription?: string | null;
  creator: ICreator;
  lastUpdatedBy: ILastUpdatedBy;
  deletedBy: IDeletedBy;
  contributors?: IContributor[];
  space: Partial<ISpace>;
  permissions?: {
    canEdit: boolean;
    hasRestriction: boolean;
  };
}

export interface IContributor {
  id: string;
  name: string;
  avatarUrl: string;
}

interface ICreator {
  id: string;
  name: string;
  avatarUrl: string;
}
interface ILastUpdatedBy {
  id: string;
  name: string;
  avatarUrl: string;
}

interface IDeletedBy {
  id: string;
  name: string;
  avatarUrl: string;
}

export interface IMovePage {
  pageId: string;
  position?: string;
  after?: string;
  before?: string;
  parentPageId?: string;
}

export interface IMovePageToSpace {
  pageId: string;
  spaceId: string;
}

export interface ICopyPageToSpace {
  pageId: string;
  spaceId?: string;
}

export interface SidebarPagesParams {
  spaceId?: string;
  pageId?: string;
  cursor?: string;
  limit?: number;
  // Scope: tab UUID, "loose" for unassigned pages, omitted = whole space.
  tabId?: string | "loose";
}

export interface IPageInput {
  pageId: string;
  title: string;
  parentPageId: string;
  icon: string;
  coverPhoto: string;
  position: string;
  isLocked: boolean;
  spaceId?: string;
  kind?: "page" | "group" | "link";
  externalUrl?: string | null;
  isGroup?: boolean;
  hidden?: boolean;
  isTab?: boolean;
  tabMeta?: ITabMeta | null;
  seoDescription?: string | null;
}

export interface IExportPageParams {
  pageId: string;
  format: ExportFormat;
  includeChildren?: boolean;
  includeAttachments?: boolean;
}

export enum ExportFormat {
  HTML = "html",
  Markdown = "markdown",
}
